<template>
  <div class="product-detail">
    <div class="img-view">
      <img
        class="product-image"
        :src="product.url"
        oncontextmenu="return false;"
      />
      <h2>备注：购买后可获得高清大图</h2>
      <!-- <div class="shadow"></div> -->
    </div>

    <div class="product-info">
      <h1 class="product-name">商品名称:{{ product.name }}</h1>
      <p class="creation-time">创作时间: {{ product.creativeTime }}</p>
      <p class="image-size">
        高清图尺寸大小: {{ product.width }}x{{ product.height }}
      </p>
      <p class="price">价格: ¥{{ product.price }}</p>
      <div class="agreement">
        <input
          type="checkbox"
          v-model="isAgreementChecked"
          id="agreement"
          required
        />
        <label for="agreement">
          我已阅读并同意
          <a @click="lookAuth">《动漫产品授权协议》</a>
        </label>
      </div>

      <button
        :class="['pay-button', isAgreementChecked ? '' : 'gray']"
        @click="goBuy"
      >
        {{ hadIdentify ? "付费购买" : "实名付费购买" }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hadIdentify: false, // 是否已经实名认证
      isAgreementChecked: false,

      product: {}, // 单个产品
      isShowAll: false,
    };
  },
  mounted() {
    setTimeout(() => {
      // 从本地获取
      this.product = JSON.parse(localStorage.getItem("product"));
      console.log("产品详情", this.product);
      // 字符串转布尔值

      this.hadIdentify = localStorage.getItem("isIdentify") === "true";
    }, 100);
  },
  methods: {
    lookAuth() {
      this.$router.push("auth");
    },
    goBuy() {
      if (!this.isAgreementChecked) {
        alert("请先阅读并同意《动漫产品授权协议》");
        return;
      }

      const token = this.getCookie("authToken");
      console.log("token", token);
      if (!token) {
        // 如果 Cookie 不存在或已过期
        alert("重新登录");
        this.$router.push("login");

        return;
      } else {
        if (!this.hadIdentify) {
          this.$router.push("identify");
          return;
        }
        this.$router.push("pay");
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    },
    formatTime(time) {
      const date = new Date(time);
      return `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },
  },
};
</script>
<style scoped lang='less'>
.product-detail {
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  // background-color: yellow;
  padding: 100px 0 0 120px;
  // 从yellow -> white 的向下渐变
  background: linear-gradient(180deg, yellow, white);
}
h2 {
  margin-top: 10px;
}
a {
  color: blue;
  cursor: pointer;
  // 去除下划线
  text-decoration: none !important;
}

.img-view {
  width: 500px;
  height: 500px;

  margin-top: 28px;
  position: relative;
}

.product-image {
  object-fit: contain;
  display: block;
  width: 500px;
  opacity: 0.5;
}
.shadow {
  width: 500px;
  height: 500px;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
}

.product-info {
  padding: 20px;
  margin-left: 100px;
}
.product-name {
  font-size: 24px;
  margin: 0 0 10px;
}

.creation-time,
.image-size,
.price {
  margin: 25px 0;
}

.gray {
  background-color: gray !important;
}
.pay-button {
  padding: 10px 20px;
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 16px;
}
.pay-button:hover {
  background-color: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue